import { render, staticRenderFns } from "./CourseUnit.vue?vue&type=template&id=18c5b14b&scoped=true"
import script from "./CourseUnit.vue?vue&type=script&lang=js"
export * from "./CourseUnit.vue?vue&type=script&lang=js"
import style0 from "./CourseUnit.vue?vue&type=style&index=0&id=18c5b14b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c5b14b",
  null
  
)

export default component.exports